const CIVIL_DATE = /^(\d{4})-(\d{2})-(\d{2})/;

const SUPPORTED_LOCALES = ["pt-BR", "en-US", "es-ES", "zh-CN"] as const;

export type Gs3DateLocale = (typeof SUPPORTED_LOCALES)[number];

const DEFAULT_LOCALE: Gs3DateLocale = "pt-BR";

const DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};

const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  ...DATE_OPTIONS,
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

export const resolveGs3DateLocale = (locale?: string | null): Gs3DateLocale =>
  locale && SUPPORTED_LOCALES.includes(locale as Gs3DateLocale)
    ? (locale as Gs3DateLocale)
    : DEFAULT_LOCALE;

/**
 * Data civil (`YYYY-MM-DD` ou ISO com hora) no idioma da sessão GS3.
 * Não usa o locale do navegador — só `pt-BR` / `en-US` / `es-ES` / `zh-CN`.
 */
export const formatDate = (
  isoDate?: string | null,
  locale?: string | null,
): string => {
  if (!isoDate) return "";

  const match = isoDate.match(CIVIL_DATE);
  if (!match) return "";

  const [, year, month, day] = match;
  const parsed = new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0);
  if (Number.isNaN(parsed.getTime())) return "";

  return new Intl.DateTimeFormat(resolveGs3DateLocale(locale), DATE_OPTIONS).format(
    parsed,
  );
};

/** Timestamp ISO → data e hora no idioma da sessão (24h, sem segundos). */
export const formatDateTime = (
  isoDate?: string | null,
  locale?: string | null,
): string => {
  if (!isoDate) return "";

  const parsed = new Date(isoDate);
  if (Number.isNaN(parsed.getTime())) return "";

  return new Intl.DateTimeFormat(
    resolveGs3DateLocale(locale),
    DATE_TIME_OPTIONS,
  ).format(parsed);
};
